import { Helmet } from 'react-helmet-async';
import ContactForm from '@components/Contact/ContactForm';
import ContactInfo from '@components/Contact/ContactInfo';
import GoogleMap from '@components/Contact/GoogleMap';
import Testimonials from '@components/Common/Testimonials';
import './Contact.css';

const Contact = () => {
  return (
    <>
      <Helmet>
        <title>Contact Us - AT Architects</title>
        <meta
          name="description"
          content="Get in touch with AT Architects for your architectural and interior design projects. We're here to bring your vision to life."
        />
        <meta property="og:title" content="Contact Us - AT Architects" />
        <meta
          property="og:description"
          content="Contact AT Architects for your project"
        />
        <link rel="canonical" href="https://atarchitects.com/contact" />
      </Helmet>

      {/* Map as Hero Section */}
      <section className="contact-hero-map">
        <GoogleMap />
        <div className="contact-hero-overlay">
          <h1 className="contact-hero-title">Get In Touch</h1>
          <p className="contact-hero-subtitle">Let's create something amazing together</p>
        </div>
      </section>

      <section className="contact-section">
        <div className="contact-container">
          <div className="contact-grid">
            {/* Contact Form */}
            <div className="contact-form-wrapper">
              <ContactForm />
            </div>

            {/* Contact Info Sidebar */}
            <div className="contact-sidebar">
              <ContactInfo />
            </div>
          </div>
        </div>
      </section>
      <Testimonials />
    </>
  );
};

export default Contact;
